<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="top_tance"></div>
    <div class="paddingContent">
      <div class="btn addBtn fr" @click="$router.push('/addVlog')">新增Vlog</div>
      <div class="tableWrap">
        <table class="customizeTable">
          <thead>
          <tr>
            <th class="normal_font" style="width:3.6rem;">ID</th>
            <th class="normal_font" style="width:3.6rem;">標題</th>
            <th class="mainImgTh normal_font">主圖</th>
            <th class="normal_font">類型</th>
            <th class="normal_font">發佈時間</th>
            <th class="normal_font">評論</th>
            <th class="normal_font">點讚</th>
            <th class="normal_font" style="width: 2.2rem;">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-show="showTips">
            <td class="normal_font" colspan="6">暫無數據</td>
          </tr>
          <tr v-for="(item, index) in diaryList" :key="index">
            <td class="normal_font table_font">{{item.id}}</td>
            <td class="normal_font table_font">{{item.title}}</td>
            <td class="mainImgWrap normal_font"><img class="mainImg" :src="item.primaryPictureUrl" alt=""><p @click="broadCast(item.vlogUrl)">播放</p></td>
            <td class="normal_font">vlog</td>
            <td class="normal_font">{{item.publishDate}}</td>
            <td class="normal_font">{{item.commentNum}}</td>
            <td class="normal_font">{{item.likeNum}}</td>
            <td class="normal_font delDiary">
              <span class="topBtn" v-if="item.roofPlacement==0" @click="toTop(item.id,1)" type="text">置頂</span>
              <span v-else type="text" @click="toTop(item.id,0)">取消置頂</span>
              <span @click="viewComments(item.id)">查看評論</span>
              <span @click="editVlog(item.id)">編輯</span>
              <span @click="delVlog(item.id)">删除</span>
              </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="5"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div v-if="imgProp"  class="propWrap">
      <div class="prop-content mobile_show">
        <i class="iconfont icon-close fr hand" @click="closeProp()"></i>
        <p class="prop-title normal_font">播放</p>
        <video style="width:100%;" controls="controls" :src="previewImgUrl" :autoplay='videoPlay'>
          您的瀏覽器不支持播放video
        </video>
        <div class="bottomBtn">
          <!--<div class="btn">取消</div>-->
          <div class="btn hand new_btn" @click="closeProp()">確認</div>
        </div>
      </div>
    </div>
    <div v-if="successTips"  class="propWrap">
      <div class="prop-content mobile_show">
        <i class="iconfont icon-close fr hand" @click="closeProp()"></i>
        <p class="prop-title">提示</p>
        <div class="show_picture"><i class="iconfont icon-success icon_font"></i></div>
        <p class="success_font">發佈成功</p>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data () {
    return {
      showTips: false,
      imgProp: false,
      successTips: false,
      previewImgUrl: '',
      navBlock: '新聞',
      navtitle: 'Vlog',
      diaryList: [],
      blockType: '',
      currentPage: 1, // 分页
      total: 0,
      videoPlay: false,
      dialogVisible: false,

    }
  },
  mounted() {
    this.showSuccessTips();
  },
  activated(){
    let _this = this;
    _this.showSuccessTips();
    if(_this.currentPage===1){
      _this.initList();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    showSuccessTips(){
      let _this=this;
      //新增Vlog成功提示
      let successPopup=localStorage.getItem('success');
      _this.initList();
      if (successPopup == '00000') {
        _this.successTips = true;
        setTimeout(() => {
          localStorage.removeItem('success');
        },1000)
      } else {
        localStorage.removeItem('success');
      };
    },
    //初始列表
    initList() {
      let _this=this;
      let param = {
        type: 2,
        page: _this.currentPage,
        size: 5
      };
      _this.$post('/request/article/getArticleList', param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.data.list == '') {
            _this.showTips = true;
          }else {
            _this.diaryList = res.data.list;
            _this.showTips = false;
          }
          _this.total = res.data.allRow;
        });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.initList();
    },
    closeProp() {
      let _this = this;
      _this.imgProp = false;
      _this.successTips = false;
    },
    broadCast(url) {
      let _this = this;
      _this.imgProp = true;
      _this.previewImgUrl = url;
      _this.videoPlay = true;
    },
    // 查看评论
    viewComments(id) {
      this.$router.push(`/viewComment?id=${id}`);
    },
    // 編輯vlog
    editVlog(id){
      let _this = this;
      _this.$router.push(`/editVlog?id=${id}`);
    },
    // 删除vlog
    delVlog(id){
      let _this = this;
      _this.$confirm('是否刪除該Vlog?', '提示信息', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        center: true,
        closeOnClickModal: false
        }).then(()=> {
          // 确认删除的回调
          _this.$get(`/request/article/deleteNews/${id}`, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible = true;
              if (res.code === '00000') {
                _this.$propMessage('刪除成功', 'success',
                  function(){
                    _this.dialogVisible = false;
                    _this.initList();
                  });
              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                    _this.dialogVisible = false;
                  });
              };
            });
      })
    },
    toTop(id,flag){
      let _this = this
      let param = {
        articleType: 2,
        articleId: id,
        top: Number(flag)
      }
      _this.$put(`/request/article/articleTop`, param, _this.$GLOBAL.jsonConfig)
            .then((res) => {
          _this.dialogVisible = true;
          if (res.code === '00000') {
            if (flag == 0) {
              _this.$propMessage('vlog取消置頂成功', 'success',
                function(){
                  _this.dialogVisible = false;
                  _this.initList();

                });
            } else {
              _this.$propMessage('vlog置頂成功', 'success',
                function(){
                  _this.dialogVisible = false;
                  _this.initList();
                });
            }
          } else if(res.code==='80001'){
            this.$confirm('同時只支持一篇vlog置頂，請取消置頂後再設置?', '提示信息', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                center: true,
                closeOnClickModal: false
              }).then(()=> {})
          } else {
            _this.$propMessage(res.message, 'error',
              function(){
                _this.dialogVisible = false;
              });
          };
        });
    }
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
  .content{

    .top_tance {
      padding-top: 0.8rem;

      @media (max-width: 768px) {
        padding-top: 22px;
      }

      @media (max-width: 420px) {
        padding-top: 62px;
      }

    }

    .paddingContent {
      height: calc(100% - 88px);
      padding: 0 0.4rem;
      background-color: #ffffff;

      @media (max-width: 768px) {
        height: calc(100% - 62px);
      }

      .addBtn {
        margin: 0.2rem 0;
        cursor: pointer;

        @media (max-width: 420px) {
          margin-top: 0.3rem;
          margin-bottom: 10px;
        }

      }

      .btn {
        @media (max-width: 420px) {
          width: 1.3rem;
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 12px;
        }
      }

      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
      .previewImg {
        width: 3.9rem;
        display: block;
        padding: 0.2rem 0 0.3rem 0;
        margin: 0 auto;
      }
    }
    .bottomBtn{
      padding-bottom: 0.4rem;
    }
    .icon-close {
      margin: 10px;
    }
    .hand {
      cursor: pointer;
    }
    .propWrap {
      .prop-content {
       height: 90%;
       overflow: auto;
        img {
          // width: 38%;
          width: 70%;
          // max-height:5rem;
          // max-height:76%;
          @media (max-width: 420px) {
            width: 50%;
          }

        }
      }
    }
    .mobile_show {
      @media (max-width: 420px) {
        top: 45%;
      }
    }

    .paging-block {
      margin: 0.2rem 0;

      @media (max-width: 420px) {
        margin: 0.3rem 0;
      }

    }

    .label_num {
      font-size: 14px;
      line-height: 32px;
    }

    .show_picture {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .icon_font {
      font-size: 60px;
    }

    .success_font {
      font-size: 16px;
      margin-top: 10px;
      margin-bottom: 40px;
      color: #606266;
    }

    .table_font {
      padding-left:0.1rem;
      padding-right:0.1rem;
    }

    .prop-title {
      color: #303133;
      padding: 0.1rem;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/news/vlog/newsVlog.vue